var s = Object.defineProperty;
var m = (t, o, a) => o in t ? s(t, o, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[o] = a;
var e = (t, o, a) => m(t, typeof o != "symbol" ? o + "" : o, a);
import { BaseEnvironment as i } from "./main6.js";
class p extends i {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    e(this, "domain", "hportal.webmotors.com.br");
    /**
     * Local http protocol
     *
     */
    e(this, "protocol", "http");
    /**
     * Enable logging for LOCAL Environment
     *
     */
    e(this, "logging", !0);
    /**
     * Disable sending headers
     *
     */
    e(this, "disabledHeaders", !0);
    /**
     * Webmotors api URL
     *
     */
    e(this, "apiURL", `https://${this.domain}/api`);
    /**
     * Webmotors private api URL
     *
     */
    e(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api");
    /**
     * SEO private api URL
     *
     */
    e(this, "seoApiPrivateURL", "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api");
    /**
     * Webmotors base URL
     *
     */
    e(this, "baseURL", `https://${this.domain}`);
    /**
     * Cookie domain on LOCAL environment
     *
     */
    e(this, "cookieDomain", [
      this.domain,
      `.${this.domain}`,
      ".webmotors.com.br",
      "localhost"
    ]);
    /**
     * Auth Cookie Name on LOCAL environment
     *
     */
    e(this, "authCookieName", "webmotors.jwt.token.hk");
    /**
     * Access Token Cookie Name on LOCAL environment
     *
     */
    e(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on LOCAL environment
     *
     */
    e(this, "refreshTokenCookieName", "webmotors.refresh.token.hk");
    /**
     * Vehicle photo path on LOCAL environment
     *
     */
    e(this, "photoPath", "https://himage.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    e(this, "chatApiUrl", "wss://hchat.webmotors.com.br");
    /**
     * Hot deal image path on LOCAL environment
     *
     */
    e(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/");
    /**
     * Data Dog Sample Config
     */
    e(this, "traceSampleRate", 0);
    e(this, "sessionSampleRate", 0);
    e(this, "sessionReplaySampleRate", 0);
    /**
     * Seller shield image path
     */
    e(this, "sellerShieldImage", "https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/");
    /**
     * Login route
     *
     */
    e(this, "loginRoute", `https://${this.domain}/login`);
  }
}
export {
  p as LocalEnvironment
};
